<div class="modal-header">
  <h5 *ngIf="user"
      id="editUserLabel"
      class="modal-title"
      i18n="@@EditUserFullName">
    Benutzer "{{ user.fullName }}" bearbeiten
  </h5>

  <button type="button"
          id="x_close"
          class="btn-close"
          (click)="onCancelClick()"
          data-bs-dismiss="modal"
          aria-label="Close"></button>
</div>

<div class="modal-body">
  <app-edit-user #editUserComponent
                 [customerId]="customerId"
                 (entityLoadedEvent)="onEntityLoadedEvent($event)">
  </app-edit-user>
</div>

<form *ngIf="formCreated"
      [formGroup]="formService.form"
      (ngSubmit)="editUserComponent.onSubmit(formService.form.value)">
  <div class="modal-footer">
    <button *ngIf="!isMasterUser"
            type="button"
            id="delete"
            class="btn btn-danger text-white col-lg-3 btn-margin"
            (click)="openDeleteDialog()"
            [disabled]="isSupporter"
            i18n="@@DeleteUserButton">
      {{ getDelButtonText() }}
    </button>

    <button *ngIf="this.user.email != null && this.user.email?.length > 0"
            type="button"
            id="reinvite"
            class="btn btn-yellow col-lg-3 btn-margin"
            (click)="sendInviteEmail()"
            i18n="@@Re-InviteButton">
      Erneut einladen
    </button>

    <button type="submit"
            id="save"
            class="btn btn-save col-lg-3 btn-margin"
            [disabled]="!formService.form.valid || !formService.unsavedChanges || editUserComponent.isBtnSaveDisabled || isSupporter"
            i18n="@@SaveChangesButton">
      Änderungen speichern
    </button>
  </div>
</form>
